import { DataEntry } from './../../shared/data-entry.interface';
import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common.service';
import { DataproviderService } from 'src/app/dataprovider.service';

/*
  Visible only when TechnologyID = 3 (MyHome_UP) [homeAutomationSystems = 'NUV']
*/

@Component({
  selector: 'app-package',
  templateUrl: './package.component.html',
  styleUrls: ['./package.component.scss'],
  host: {
    class: 'center-route-content'
  }
})
export class PackageComponent implements OnInit {
  title: string = "b2c.IDS_PACKAGES";
  subtitle: string = "b2c.IDS_PACKAGES_SUB";
  question: string = "b2c.IDS_PACKAGES_QUE";
  activePage: string = "package";
  nextPage: string = "switch";
  dataEntries: DataEntry[] = [
    { ID: 1, name:"b2c.IDS_BASE", name_ref: "base", description: "", tooltip: "b2c.IDS_BASE_TIP", checked: false }, 
    { ID: 2, name:"b2c.IDS_FULL", name_ref: "full", description: "", tooltip: "b2c.IDS_FULL_TIP", checked: false }
  ];

  constructor(
    private cs: CommonService,
    private ds: DataproviderService
  ) {
    this.cs.setParams(this.title, this.subtitle, this.question, this.activePage, this.nextPage, false, true, false, true, null, false);
  }

  ngOnInit() {
  }

  dataEntriesUpdate(idSelected: number){
    /* single selection */
    for (let data of this.dataEntries) {
      if ( data.ID == idSelected ) { data.checked = true; } else { data.checked = false; }
    }
    this.cs.updateNextBtn(true);
  }

  onSelectorClicked(idSelected: number){
    this.dataEntriesUpdate(idSelected);
    this.ds.setPackagesType(idSelected);
  } 
}
